module.exports = __webpack_public_path__ + "img/p2_btn_link.1cba3d64.png";